
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function SearchSection() {
  const [searchType, setSearchType] = useState('buy');
  const [propertyType, setPropertyType] = useState('');
  const [area, setArea] = useState('');
  const [priceRange, setPriceRange] = useState('');

  const propertyTypes = [
    { value: 'mansion', label: 'マンション' },
    { value: 'house', label: '一戸建て' },
    { value: 'land', label: '土地' },
    { value: 'commercial', label: '事業用' }
  ];

  const areas = [
    { value: 'shibuya', label: '渋谷区' },
    { value: 'minato', label: '港区' },
    { value: 'shinjuku', label: '新宿区' },
    { value: 'chiyoda', label: '千代田区' },
    { value: 'chuo', label: '中央区' }
  ];

  const priceRanges = [
    { value: '0-3000', label: '〜3,000万円' },
    { value: '3000-5000', label: '3,000〜5,000万円' },
    { value: '5000-8000', label: '5,000〜8,000万円' },
    { value: '8000-12000', label: '8,000万円〜1億2,000万円' },
    { value: '12000+', label: '1億2,000万円〜' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-center mb-8 text-gray-900">
              物件検索
            </h2>
            
            <div className="flex justify-center mb-8">
              <div className="bg-gray-100 rounded-full p-1 flex">
                <button
                  onClick={() => setSearchType('buy')}
                  className={`px-6 py-2 rounded-full whitespace-nowrap cursor-pointer transition-colors ${
                    searchType === 'buy' 
                      ? 'bg-blue-600 text-white' 
                      : 'text-gray-600 hover:text-blue-600'
                  }`}
                >
                  購入
                </button>
                <button
                  onClick={() => setSearchType('rent')}
                  className={`px-6 py-2 rounded-full whitespace-nowrap cursor-pointer transition-colors ${
                    searchType === 'rent' 
                      ? 'bg-blue-600 text-white' 
                      : 'text-gray-600 hover:text-blue-600'
                  }`}
                >
                  賃貸
                </button>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  物件種別
                </label>
                <div className="relative">
                  <select
                    value={propertyType}
                    onChange={(e) => setPropertyType(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-8 cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    {propertyTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  エリア
                </label>
                <div className="relative">
                  <select
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-8 cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    {areas.map((areaItem) => (
                      <option key={areaItem.value} value={areaItem.value}>
                        {areaItem.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  価格帯
                </label>
                <div className="relative">
                  <select
                    value={priceRange}
                    onChange={(e) => setPriceRange(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-8 cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    {priceRanges.map((range) => (
                      <option key={range.value} value={range.value}>
                        {range.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="text-center">
              <Button size="lg" className="px-12 py-4 text-lg">
                <i className="ri-search-line mr-2"></i>
                物件を検索する
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
